export const getSanitizedUrl = (unsanitizedUrl: string | undefined | null) => {
  let sanitizedUrl = undefined;
  try {
    // do not crash if unsanitizedUrl is a string, but not valid
    if (unsanitizedUrl && new URL(unsanitizedUrl).protocol.startsWith("http")) {
      // prevent XSS
      sanitizedUrl = unsanitizedUrl;
    }
  } catch (e) {
    console.error(
      `Provided repo_url '${unsanitizedUrl}' does not conform to http protocol, so links will not be displayed on page`
    );
  }

  // Remove any extraneous users from url- returned by Azure in this format
  if (sanitizedUrl) {
    sanitizedUrl = sanitizedUrl.replace(/https:\/\/.*@/i, "https://");
  }

  return sanitizedUrl;
};
